import { type FC } from 'react';

import EyeIcon from '@/assets/svg/ui-elements/eye-outline.svg';
import EyeSlashIcon from '@/assets/svg/ui-elements/eye-slash-outline.svg';

import { StyledRevealToggleButton } from './RevealToggle.styled';
import type { RevealToggleProps } from './types';

/**
 * Toggle that gates sensitive values behind an explicit user action. Pair it
 * with masked rendering (see `maskTrailing` / `maskAddressToCity`) so values
 * stay hidden until the user asks for them, and keep the `revealed` state in
 * component state so it resets on reload.
 */
const RevealToggle: FC<RevealToggleProps> = ({
  revealed,
  onToggle,
  revealLabel = 'View',
  hideLabel = 'Hide',
  controlsId,
  color = 'tertiary',
  variant = 'ghost',
  size = 'sm',
  fullWidth = false,
  disabled = false,
  className,
}) => (
  <StyledRevealToggleButton
    type="button"
    color={color}
    variant={variant}
    size={size}
    fullWidth={fullWidth}
    disabled={disabled}
    aria-pressed={revealed}
    aria-controls={controlsId}
    onClick={() => onToggle(!revealed)}
    className={className}
  >
    {revealed ? <EyeSlashIcon aria-hidden /> : <EyeIcon aria-hidden />}
    {revealed ? hideLabel : revealLabel}
  </StyledRevealToggleButton>
);

RevealToggle.displayName = 'RevealToggle';

export default RevealToggle;
